import { createSelector } from 'reselect'

const getWorkOrders = (state, props) => state.workOrders
const getWorkOrderId = (state, props) => props.params.workOrderId

export const getWorkOrderById = createSelector(
  [getWorkOrders, getWorkOrderId],
  (workOrders, workOrderId) => workOrders[workOrderId]
)



// WEBPACK FOOTER //
// ./src/selectors/work-order-selectors.js